


































import { Component, Prop, Vue } from "vue-property-decorator";
import { Post, RecurenceEnum, WeekdaysEnum, DatesOfMonth, MarkedDay, ActiveDaysRequest, Time } from "@/services/posts/types";
import moment from "moment";
import { moveEntity } from "@/services/folders/folderService";

@Component
export default class PostScheduleValidation extends Vue {
    @Prop() private item!: Post;

    recurenceEnum = RecurenceEnum;
    weekdaysEnum = WeekdaysEnum;
    datesOfMonth = DatesOfMonth;

    // methods
    isValid() {
        var isValid = this.validateToDate && this.validateFromTime && this.validateToTime && this.validateWeekly &&
            this.validateMonthly && this.validateYearly;
        return isValid;
    }

    // validations
    // computed
    get validateToDate() {
        if (this.item.neverending) {
            return true;
        }
        return !(!this.item.neverending && !this.item.toDate) && new Date(this.item.toDate).setHours(0, 0, 0, 0) >= new Date(this.item.fromDate).setHours(0, 0, 0, 0);
    }

    get validateToTime() {
        if (this.item.allDay) {
            return true;
        }
        var hour = moment(this.item.toTime, "HH:mm").isSameOrAfter(moment(this.item.fromTime, "HH:mm"), "minute");
        var minute = moment(this.item.toTime, "HH:mm").isSameOrAfter(moment(this.item.fromTime, "HH:mm"), "hour");
        return this.item.toTime.length === 5 && this.item.toTime.includes(":") && hour && minute;
    }

    get validateFromTime() {
        if (this.item.allDay) {
            return true;
        }
        return this.item.fromTime.length === 5 && this.item.fromTime.includes(":");
    }

    get validateYearly() {
        if (this.item.recurenceType !== this.recurenceEnum.yearly) {
            return true;
        }

        if (this.item.yearly == null || this.item.yearly === "") return false;

        return !(this.item.recurenceType === this.recurenceEnum.yearly && !this.item.yearly) && this.item.neverending ? true : new Date(this.item.toDate).setHours(0, 0, 0, 0) >= new Date(this.item.yearly).setHours(0, 0, 0, 0);
    }

    get validateWeekly() {
        if (this.item.recurenceType !== this.recurenceEnum.weekly) {
            return true;
        }
        return (this.item.recurenceType === this.recurenceEnum.weekly) && (this.item.recurenceValues.length > 0) && this.checkIfSelectedDaysExistsInRange();
    }

    get validateMonthly() {
        if (this.item.recurenceType !== this.recurenceEnum.monthly) {
            return true;
        }
        return (this.item.recurenceType === this.recurenceEnum.monthly) && (this.item.recurenceValues.length > 0) && this.checkIfSelectedDatesAreInDateRage();
    }

    // helper methods
    checkIfSelectedDatesAreInDateRage() {
        if (this.item.neverending) {
            return true;
        } else {
            var result = [] as Array<Date>;
            var range = [] as Array<Date>;
            var from = new Date(this.item.fromDate);
            from.setHours(0, 0, 0, 0);
            var to = new Date(this.item.toDate);
            to.setHours(0, 0, 0, 0);
            range = this.getDateRange();
            this.item.recurenceValues.forEach(selected => {
                range.forEach(inRange => {
                    var selectedDate = new Date(inRange.getFullYear(), inRange.getMonth(), selected);
                    selectedDate.setHours(0, 0, 0, 0);
                    if (from <= selectedDate && selectedDate <= to) {
                        result.push(selectedDate);
                    }
                });
            });
            return result.length > 0;
        }
    }

    checkIfSelectedDaysExistsInRange() {
        if (this.item.neverending) {
            return true;
        } else {
            var start = moment(new Date(this.item.fromDate), "YYYY-MM-DD");
            var end = moment(new Date(this.item.toDate), "YYYY-MM-DD");
            var result = [] as Array<any>;
            var daysDiff = end.diff(start, "days");
            this.item.recurenceValues.forEach(day => {
                var current = start.clone();
                if (daysDiff >= 7) {
                    result.push(current.clone());
                } else {
                    current.day(day === 7 ? 0 : day);
                    start.day(start.day() - 1);
                    end.day(end.day() + 1);
                    while (current.isSameOrBefore(start)) {
                        current.add(1, "weeks");
                    }
                    while (current.isBetween(start, end)) {
                        result.push(current.clone());
                        current.add(7, "days");
                    }
                }
            });
        }
        return result.length > 0;
    }

    getDateRange() {
        var range = [];
        var current = new Date(this.item.fromDate);
        var end = new Date(this.item.toDate);
        while (current <= end) {
            range.push(new Date(current));
            current = new Date(current.setDate(current.getDate() + 1));
        }
        return range;
    }
}
